
  <div *ngIf="allowCreate">
    <div *ngIf="fechas && fechas.length > 0">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Fecha de evaluación relacionada</mat-label>
        <mat-select [value]="selectedDate" [(ngModel)]="selectedDate">
          <mat-option [value]="">Seleccione una fecha</mat-option>
          <mat-option *ngFor="let fecha of fechas" [value]="fecha">
            {{fecha}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-form-field class="comment-top" appearance="outline">
      <mat-label>Comentario</mat-label>
      <textarea matInput
                [placeholder]='textoPlaceHolder'
                matTextareaAutosize matAutosizeMinRows="1"
                matAutosizeMaxRows="12"
                #nuevoHilo
                class="comment-box"></textarea>
    </mat-form-field>
    <div class="comments-buttons">
      <button mat-raised-button color="primary" (click)="guardarComentario(nuevoHilo, targetID, origen)" [disabled]="!allowResponse">Aceptar</button>
      <button mat-button color="primary" style="margin-left: 8px;" (click)="nuevoHilo.value = ''">Cancelar</button>
    </div>
  </div>
  <div class="comments-thread">
    <ng-container *ngFor="let comentario of comentarios">
      <div class="comments-thread__comment">
        <div class="flex-wrap comments-thread__commenter">
          <p style="font-size: 12px; opacity: 0.6;">
            <b>{{comentario.creadoPor | lowercase}}</b>
            <br>{{comentario.fecha}}
          </p>
          <span class="spacer"></span>
          <div>
            <ng-container class="flex-wrap" *ngFor="let leidoPor of comentario.leidoPor">
                <mat-icon *ngIf="leidoPor.userImage == null"
                  class="md-14"
                  [matTooltip]="leidoPor.by"
                  color='accent'
                  role="tooltip">account_circle</mat-icon>
                <img *ngIf="leidoPor.userImage != null"
                  class="userMenuChip__img md-14"
                  [matTooltip]="leidoPor.by"
                  #userPic src="{{leidoPor.imageUrl}}"
                >
            </ng-container>

            <button mat-icon-button class="md-14" *ngIf="comentario.isEditable"
                    (click)="activarEdicion(comentario, true)">
              <mat-icon class="md-14">edit</mat-icon>
            </button>
            <button mat-icon-button class="md-14"
                    *ngIf="comentario.isEditable"
                    (click)="eliminarComentario(comentario, 0)">
              <mat-icon class="md-14">delete</mat-icon>
            </button>
            <ng-container *ngIf="!comentario.leido">
              <button mat-icon-button class="md-14" color="warn" (click)="marcarLeido(comentario)">
                <mat-icon class="md-14">notifications</mat-icon>
              </button>
            </ng-container>
          </div>
        </div>
        <!-- <div > -->
          <!-- <ng-container class="flex-wrap" *ngFor="let leidoPor of comentario.leidoPor"> -->
            <!-- <div matTooltip="{{leidoPor.nombresApellidos}}" role="tooltip"> -->
              <!-- <mat-icon *ngIf="leidoPor.userImage == null" matTooltip='{{leidoPor.nombresApellidos}}' color='accent' role="tooltip">account_circle</mat-icon> -->
              <!-- <img *ngIf="leidoPor.userImage != null" #userPic src="{{leidoPor.imageUrl}}" class="userMenuChip__img"> -->
            <!-- </div> -->
          <!-- </ng-container> -->
        <!-- </div> -->
        <div>
          <ng-container *ngIf="comentario.editando">
            <mat-form-field class="comment-top" appearance="outline">
              <mat-label>Comentario</mat-label>
              <textarea matInput matTextareaAutosize matAutosizeMinRows="1" #editHilo
                        class="comment-box">{{comentario.comentario}}</textarea>
            </mat-form-field>
            <div class="comments-buttons">
              <button mat-raised-button color="primary" (click)="editarComentario(editHilo.value, comentario)">Aceptar
              </button>
              <button mat-button color="primary" (click)="activarEdicion(comentario, false)" style="margin-left: 8px;">
                Cancelar
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="!comentario.editando">
            <div style="margin-bottom: 8px; white-space: pre-wrap;">
              {{comentario.comentario}}
            </div>
          </ng-container>
        </div>
        <div class="comments-buttons">
          <button mat-raised-button class="md-14" (click)="responderComentario(comentario)"
                  *ngIf="!comentario.responder">Responder
          </button>
          <br>
          <div *ngIf="comentario.responder">
            <mat-form-field class="comment-top" appearance="outline">
              <mat-label>Respuesta</mat-label>
              <textarea matInput placeholder="Respuesta" matTextareaAutosize matAutosizeMinRows="1" #nuevoHilo
                        class="comment-box"></textarea>
            </mat-form-field>
            <div class="comments-buttons">
              <button mat-raised-button (click)="guardarComentario(nuevoHilo, comentario.id, 'comentario')">Aceptar
              </button>
              <button mat-button (click)="comentario.responder = false" style="margin-left: 8px;">
                Cancelar
              </button>
            </div>
          </div>
        </div>
        <ng-container *ngIf="comentario.comentarios && comentario.comentarios.length > 0">
          <div class="comments-thread__answer">
            <ng-container *ngFor="let respuesta of comentario.comentarios">
              <div class="flex-wrap">
                <p style="font-size: 12px; opacity: 0.6;">
                  <b>{{respuesta.creadoPor | lowercase}}</b>
                  <br> {{respuesta.fecha}}
                </p>
                <span class="spacer"></span>
                <div>
                  <button mat-icon-button class="md-14" *ngIf="respuesta.isEditable"
                          (click)="activarEdicion(respuesta, true)">
                    <mat-icon class="md-14">edit</mat-icon>
                  </button>
                  <button mat-icon-button class="md-icon-button-14"
                          *ngIf="respuesta.isEditable"
                          (click)="eliminarComentario(respuesta, comentario.id)">
                    <mat-icon class="md-14">delete</mat-icon>
                  </button>
                  <ng-container *ngIf="!respuesta.leido">
                    <button mat-icon-button class="md-14" color="warn" (click)="marcarLeido(respuesta)">
                      <mat-icon class="md-14">notifications</mat-icon>
                    </button>
                  </ng-container>
                </div>
              </div>
              <div class="flex-wrap">
                <ng-container *ngFor="let leidoPor of respuesta.leidoPor">
                  <div matTooltip="{{leidoPor.nombresApellidos}}">
                    <mat-icon *ngIf="leidoPor.userImage == null">account_circle
                    </mat-icon>
                    <img *ngIf="leidoPor.userImage != null" #userPic src="{{leidoPor.imageUrl}}"
                         class="userMenuChip__img">
                  </div>
                </ng-container>
              </div>
              <div>
                <ng-container *ngIf="respuesta.editando">
                  <mat-form-field class="comment-top" appearance="outline">
                    <mat-label>Comentario</mat-label>
                    <textarea matInput matTextareaAutosize matAutosizeMinRows="1" #editRespuesta
                              class="comment-box">{{respuesta.comentario}}</textarea>
                  </mat-form-field>
                  <div class="comments-buttons">
                    <button mat-raised-button (click)="editarComentario(editRespuesta.value, respuesta)">
                      Aceptar
                    </button>
                    <button mat-button (click)="activarEdicion(respuesta, false)" style="margin-left: 8px;">
                      Cancelar
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!respuesta.editando">
                  <div style="margin-bottom: 16px;">
                    {{respuesta.comentario}}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>

